import { render } from "./TicketShop.vue?vue&type=template&id=6a2156bc&scoped=true"
import script from "./TicketShop.vue?vue&type=script&lang=js"
export * from "./TicketShop.vue?vue&type=script&lang=js"

import "./TicketShop.vue?vue&type=style&index=0&id=6a2156bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a2156bc"]])

export default __exports__